<template>
    <div :style="indent" class="tree2ItemContainer" 
            >
       <!--  <div v-show="children.length" class="treeExpander2" style="cursor: pointer" @click="doExpand">{{ isExpanded ? '&nbsp;- ' : ' + ' }}</div>
        <div v-show="!children.length" class="treeExpander2">&nbsp;</div> -->
        <!-- <input ref="cb" type="checkbox" @click="clicked" :checked="isSelected"/> -->
        <div  class="is-inline">
            
            <div class="left5 handCursor">
                <div v-show="selected && top == 1" class="has-text-coolGreen cmsPosMarker top-7">&nbsp;&nbsp;&nbsp;----------------</div>
                <div ><!-- <input ref="cb" type="checkbox" @click="selectParent"/><span class="has-text-coolGreen has-text-weight-normal"></span> -->
                    <span class="has-text-weight-normal pageLabel left5" @click="selectIndex" :class="{'has-text-coolGreen': highlight}"> &bull; {{item.name}}</span>
                    </div>
                    <div v-show="selected && top == 0" class="has-text-coolGreen cmsPosMarker">&nbsp;&nbsp;&nbsp;----------------</div>
                    <div v-show="selected && top == 2" class="has-text-coolGreen cmsPosMarker">&nbsp;&nbsp;&nbsp; &gt;&gt; --------------</div>
            </div>

        </div>
            <helpTree2  v-for="(item, ind4) in item.children" 
                :key="ind4" 
                :item="item" 
                :depth="depth + 1" 
                >
          </helpTree2>
         
    </div>
</template>

<script>
    import { AZEventBus } from './AZEventBus'


    export default { 
        name: 'helpTree2',
        props: ['item', 'depth'],
        data: function(){
            return {
               //parentSelected: null,
               indexSelected: null,
               selected: false,
               top: 2,
               highlight: false
            }
        },
        created(){
           
            //if(this.depth > 0)
                //this.path.push({id: this.id, listName: this.listName})
              
        },
       

        mounted: function(){
            var self = this
         

            AZEventBus.$on('indexSelected', this.indexSelectedHandler)
            AZEventBus.$on('cmsAutoSelectNode', this.cmsAutoSelectNodeHandler)
        },

        beforeDestroy: function(){
            AZEventBus.$off('indexSelected', this.indexSelectedHandler)
            AZEventBus.$off('cmsAutoSelectNode', this.cmsAutoSelectNodeHandler)
        },

        methods: {

            indexSelectedHandler: function(msg){
                if(msg.id != this.item.id)
                    this.selected = false
            },

            cmsAutoSelectNodeHandler: function(){
                if(msg.id == this.item.id)
                    this.highlight = true
            },
        

            selectIndex: function(){

                if(this.highlight)
                    return

                 
                this.selected = true
                
                if(this.depth == 0){
                    this.top = 2
                    AZEventBus.$emit('indexSelected', {id: this.item.id, parent: this.item.id, topOrBot: 2})
                    return
                }

                var self = this;
                
                if(this.top == 0)
                    this.top = 1
                else if(this.top == 1)
                    this.top = 2
                else if(this.top == 2)
                    this.top = 0

                AZEventBus.$emit('indexSelected', {id: this.item.id, parent: this.item.parent, topOrBot: this.top})
            },


            editPage: function(obj){
                var index = -1
                var isLanding = true
                this.$root.app.doShowModal('modalNewPage', {createOrEdit: 'edit', item: obj, isLanding: isLanding ? 1:0, index: index})
            },
        },
        computed: {
            indent() {
                return this.depth == 0 ? '' : { 'margin-left': '15px' }//transform: 'translate(20px)'
            }
        }
    }
</script>